export const jamPassword = 'Jam-2021!'